"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = require("../../../styles/colors");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    appearance: none;\n    width: 100%;\n    line-height: 28px;\n    height: 32px;\n    border: 1px solid ", ";\n    border-radius: 1rem;\n    padding: 0 28px 0 12px;\n    background-color: ", ";\n    color: #061c3f;\n    font-size: 14px;\n    transition: all 0.1s linear;\n    box-sizing: border-box;\n    text-transform: none;\n\n    :focus,\n    :active {\n        outline: 0;\n        border: 1px ", " solid;\n        box-shadow: 0 0 2px ", ";\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledSelect = _styledComponents["default"].select(_templateObject(), _colors.COLOR_GRAY_2, _colors.COLOR_WHITE, _colors.COLOR_BRAND, _colors.COLOR_BRAND);

var _default = StyledSelect;
exports["default"] = _default;